const ss_ajax = async function (url, data) {
    const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    return await new Promise((resolve, reject) => {
        this.$axios({
            method: "post",
            url,
            data
        })
        .then((res) => {
            //这里使用了ES6的语法

            loading.close();
            resolve(res.data);

        })
        .catch(
            (error) => console.log(error) //请求失败返回的数据
        );
    })
     
}

export default ss_ajax